import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ae437ea2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-people-fill" }),
  /*#__PURE__*/_createTextVNode("Meetings:")
], -1))
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-calendar2-check" }),
  /*#__PURE__*/_createTextVNode("Inter:")
], -1))
const _hoisted_6 = { key: 2 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-emoji-angry" }),
  /*#__PURE__*/_createTextVNode("Langoliers:")
], -1))
const _hoisted_8 = { key: 3 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-circle clickable" }),
  /*#__PURE__*/_createTextVNode(" Forcemajour:")
], -1))
const _hoisted_10 = {
  key: 0,
  class: "status-item-duplicates"
}
const _hoisted_11 = { class: "status-item-span" }
const _hoisted_12 = { key: 4 }
const _hoisted_13 = { class: "status-item-time" }
const _hoisted_14 = { key: 5 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "OVERLAPS", -1))
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-people-fill" }),
  /*#__PURE__*/_createTextVNode("Meetings:")
], -1))

import { EffortSummary, StatusSummary } from '@/app.context/workspace/persons/sunrise.rmodel'
//import { IResolution } from '@/app.context/workspace/persons/sunrises/effort.rmodel';
import { minuteCalc } from "@/logic/_infra/time";
import dayjs from 'dayjs';


import TodoTitleComponent from '@/components/Workspaces/todos/_spec/TodoTitleComponent.vue';
import { TicketRmodel } from '@/app.context/workspace/ticket.rmodel';
import sys from '@/sys';
import { effortQueueOperationCss, queueUpdateCss, effortStatsResolutionCss } from '@/controllers/workspaces/persons/effort.controller'

import EffortTitleComponent from '@/app/workspace/persons/EffortTitleComponent.vue'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'EffortStatusSubcomponent',
  props: {
    status: {},
    showOverlaps: { type: Boolean }
  },
  setup(__props: any) {




//import { EffortSummary } from '@/app.context/workspace/persons/sunrise.rmodel';

const props = __props

const data = computed(() => props.status?.status_exacts.overlaps)

// props.log[0].report.period.timepoint

const h = {

        todoCreate(ticket: TicketRmodel | null) {


                if (ticket != null) {
                        const s = props.status

                        if (s != null) {

                                s.person

                                //@renewal="(p: PersonRmodel, t: TicketRmodel) => ticketProcessor.taskCreate_person(context, p, t.n, TqueuePosition.DefaultRestorePostion)"

                                sys.warn("todo")
                                alert("todo task create")

                        }
                        else sys.warn("/workspaces/person - Can't create/reopen todo - person is null")
                }
                else sys.warn("/workspaces/person - Can't create/reopen todo - ticket is null")
        }
}

//resolutions: Map<string, (IResolution|null)[]


return (_ctx: any,_cache: any) => {
  return (_ctx.status != null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass({ 'mn-red-element': !_ctx.status.status_detalization.holistic })
        }, "Holistic: " + _toDisplayString(_ctx.status.status_detalization.holistic), 3), [
          [_vShow, !_ctx.status.status_detalization.holistic]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass({ 'mn-red-element': _ctx.status.status_detalization.graytime > 0 })
        }, "Gray time: " + _toDisplayString(_ctx.status.status_detalization.graytime) + "m", 3), [
          [_vShow, _ctx.status.status_detalization.graytime > 0]
        ]),
        (_ctx.status.status.meetings > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("span", null, _toDisplayString(_unref(minuteCalc).toAproximatedHoursString(_ctx.status.status.meetings)), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.status.status.intertask > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("span", null, _toDisplayString(_unref(minuteCalc).toAproximatedHoursString(_ctx.status.status.intertask)), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.status.status.langoliered > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("span", null, _toDisplayString(_unref(minuteCalc).toAproximatedHoursString(_ctx.status.status.langoliered)), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.status.status.forcemajour > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("span", null, _toDisplayString(_unref(minuteCalc).toAproximatedHoursString(_ctx.status.status.forcemajour)), 1)
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.status.timestats, (s, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `${s.time}.${i}`
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["status-item-icon", _unref(effortStatsResolutionCss)(s.resolution, s.effort)])
            }, null, 2),
            _createVNode(EffortTitleComponent, {
              effort: s.effort,
              active: _ctx.status.person.isRenewable(s.effort.ticket, s.effort.todo_type),
              onTask: _cache[0] || (_cache[0] = (t)=>h.todoCreate(t))
            }, null, 8, ["effort", "active"]),
            (s.duplicates > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, "[D]"))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(minuteCalc).toAproximatedHoursString(s.minutes)), 1)
          ]))
        }), 128)),
        (_ctx.status.pqupdates.length > 0)
          ? (_openBlock(), _createElementBlock("hr", _hoisted_12))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.status.pqupdates, (s, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `${s.time}.${i}`
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["status-item-icon", _unref(effortQueueOperationCss)(s.resolution, s.type, s.native)])
            }, null, 2),
            _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(dayjs)(new Date(s.time)).format('HH:mm')), 1),
            _createVNode(TodoTitleComponent, {
              model: s,
              active: _ctx.status.person.isRenewable(s.ticket, s.todo_type),
              onTask: _cache[1] || (_cache[1] = (t)=>h.todoCreate(t))
            }, null, 8, ["model", "active"])
          ]))
        }), 128)),
        ((_ctx.showOverlaps ?? true) && _ctx.status.status_exacts.overlaps.total() > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _hoisted_15,
              (data.value != null)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (data.value.meetings > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _hoisted_17,
                          _createElementVNode("span", null, _toDisplayString(_unref(minuteCalc).toAproximatedHoursString(data.value.meetings)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.tickets, (c) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: c[0]
                      }, [
                        _createElementVNode("span", null, "Ticket #" + _toDisplayString(c[0]) + ":", 1),
                        _createElementVNode("span", null, _toDisplayString(_unref(minuteCalc).toAproximatedHoursString(c[1])), 1)
                      ]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.tasks, (c) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: c[0]
                      }, [
                        _createElementVNode("span", null, "Task #" + _toDisplayString(c[0]) + ":", 1),
                        _createElementVNode("span", null, _toDisplayString(_unref(minuteCalc).toAproximatedHoursString(c[1])), 1)
                      ]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.derivative, (c) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: c[0]
                      }, [
                        _createElementVNode("span", null, "Derivatine " + _toDisplayString(c[0]) + ":", 1),
                        _createElementVNode("span", null, _toDisplayString(_unref(minuteCalc).toAproximatedHoursString(c[1])), 1)
                      ]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.categories, (c) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: c[0]
                      }, [
                        _createElementVNode("span", null, "Category " + _toDisplayString(c[0]) + ":", 1),
                        _createElementVNode("span", null, _toDisplayString(_unref(minuteCalc).toAproximatedHoursString(c[1])), 1)
                      ]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.notices, (c) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: c[0]
                      }, [
                        _createElementVNode("span", null, "Notice " + _toDisplayString(c[0]) + ":", 1),
                        _createElementVNode("span", null, _toDisplayString(_unref(minuteCalc).toAproximatedHoursString(c[1])), 1)
                      ]))
                    }), 128))
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})